

























import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import OrgChart from "@/components/orgchart/OrganizationChartContainer.vue";
import PageRequest from "@/store/entities/page-request";
import SearchTree from "@/lib/Common/searchtree";

class PageUserRequest extends PageRequest {
  keyword: string;
  areaId: number;
}

@Component({
  components: { OrgChart },
})
export default class Topology extends AbpBase {
  pagerequest: PageUserRequest = new PageUserRequest();
  treedata: [] = [];
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  itemId: string = "0";
  height: number = 300;
  splitnum: number = 0.15;

  async created() {
    await this.getAreaTree();
    this.pagerequest.maxResultCount = 10;
    this.pagerequest.areaId = 1;
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    //this.treedata = [];
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //区域节点变动
  async getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      if (item[0].id.length < 10) {
        this.pagerequest.areaId = item[0].id;
      } else {
        this.pagerequest.areaId = 0;
      }
    }
    await this.getTopology();
  }
  //获取拓扑数据
  async getTopology() {
    await this.$store
      .dispatch({ type: "meter/getMeterTopology", data: this.pagerequest })
      .then((val) => {
        this.treedata = val;
        console.log(this.treedata);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //节点选择
  selectNode(nodeData) {
    alert("node " + nodeData.name + " is selected");
  }
}
